/* Luzzart · Coleção v5. Gaveta de filtros (foco preso, Esc, rolagem travada), filtros e ordenação sem recarregar (Section
   Rendering + history.pushState), "Ver mais modelos", barra fixa abaixo do cabeçalho do tema e acordeão com uma pergunta
   aberta por vez. Sem JavaScript, o painel é um formulário GET e "Ver mais modelos" é um link de página. */
(function () {
  'use strict';

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, summary, [tabindex="0"]';

  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  /* a barra de filtros gruda logo abaixo do cabeçalho do tema, se ele ficar fixo ou grudado ao rolar */
  function stickyOffset() {
    /* o seletor com vírgula devolve o 1º elemento na ordem do documento (a barra de avisos vem antes do cabeçalho): testa em ordem */
    var h = null;
    ['#shopify-section-header-1', '.hdr_wrap', 'header.header', '.header-wrapper', 'header'].some(function (sel) { h = document.querySelector(sel); return !!h; });
    function medir() {
      var top = 0;
      if (h) {
        var cs = getComputedStyle(h);
        var alvo = h;
        if (cs.position !== 'fixed' && cs.position !== 'sticky' && h.firstElementChild) { alvo = h.firstElementChild; cs = getComputedStyle(alvo); }
        if (cs.position === 'fixed' || cs.position === 'sticky') top = Math.max(0, Math.round(alvo.getBoundingClientRect().bottom));
      }
      document.documentElement.style.setProperty('--lzc-top', top + 'px');
    }
    var raf = 0;
    function agenda() { cancelAnimationFrame(raf); raf = requestAnimationFrame(medir); }
    medir();
    /* o tema troca a classe do cabeçalho depois do evento de rolagem (e anima a entrada): mede de novo a cada mudança */
    if (h && window.MutationObserver) new MutationObserver(agenda).observe(h, { attributes: true, attributeFilter: ['class', 'style'] });
    if (h) { h.addEventListener('animationend', agenda); h.addEventListener('transitionend', agenda); }
    window.addEventListener('scroll', agenda, { passive: true });
    window.addEventListener('resize', agenda);
  }

  function initMain(root) {
    if (root.__lzc) return;
    root.__lzc = true;
    var sid = root.getAttribute('data-section-id');
    var base = root.getAttribute('data-base') || location.pathname;
    var form = qs(root, '[data-lzc-form]');
    var drawer = qs(root, '[data-lzc-drawer]');
    var sort = qs(root, '[data-lzc-sort]');
    var opener = null, timer = 0, busy = null, atual = location.pathname + location.search;

    /* ---------- gaveta ---------- */
    function abrir(btn) {
      if (!drawer) return;
      opener = btn || null;
      drawer.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      qsa(root, '[data-lzc-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var t = qs(drawer, '.lzc-drawer__title');
      if (t) t.focus({ preventScroll: true });
    }
    function fechar() {
      if (!drawer || drawer.hidden) return;
      drawer.hidden = true;
      document.documentElement.style.overflow = '';
      qsa(root, '[data-lzc-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (opener && opener.offsetParent !== null) opener.focus({ preventScroll: true });
      opener = null;
    }
    root.addEventListener('click', function (e) {
      var o = e.target.closest('[data-lzc-open]');
      if (o) { e.preventDefault(); abrir(o); return; }
      if (e.target.closest('[data-lzc-close]')) { e.preventDefault(); fechar(); }
    });
    document.addEventListener('keydown', function (e) {
      if (!drawer || drawer.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); fechar(); return; }
      if (e.key !== 'Tab') return;
      var l = qsa(drawer, FOCUSABLE).filter(function (x) { return x.offsetParent !== null; });
      if (!l.length) return;
      var p = l[0], u = l[l.length - 1], at = document.activeElement;
      if (e.shiftKey && (at === p || !drawer.contains(at) || at.classList.contains('lzc-drawer__title'))) { e.preventDefault(); u.focus(); }
      else if (!e.shiftKey && (at === u || !drawer.contains(at))) { e.preventDefault(); p.focus(); }
    });

    /* ---------- filtros e ordenação sem recarregar ---------- */
    function urlDoForm() {
      var p = new URLSearchParams();
      var s = sort ? sort.value : '';
      if (s) p.set('sort_by', s);
      if (form) {
        new FormData(form).forEach(function (v, k) {
          if (k === 'sort_by') return;
          if (k === 'lzc_preco') {
            var a = String(v).split('|');
            if (a[0]) p.set('filter.v.price.gte', a[0]);
            if (a[1]) p.set('filter.v.price.lte', a[1]);
          } else if (v !== '') {
            p.append(k, v);
          }
        });
      }
      var q = p.toString();
      return base + (q ? '?' + q : '');
    }

    function buscar(url) {
      var u = new URL(url, location.origin);
      u.searchParams.set('section_id', sid);
      return fetch(u.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (t) { return new DOMParser().parseFromString(t, 'text/html'); });
    }

    function sincronizarSchema() {
      var script = qs(root, '[data-lzc-schema]');
      if (!script) return;
      try {
        var schema = JSON.parse(script.textContent);
        var items = qsa(root, '[data-lzc-grid] > a.lzc-card').map(function (card, index) {
          var name = qs(card, '.lzc-card__name');
          return { '@type': 'ListItem', position: index + 1, url: card.href, name: name ? name.textContent.trim() : '' };
        });
        schema.mainEntity.numberOfItems = items.length;
        schema.mainEntity.itemListElement = items;
        script.textContent = JSON.stringify(schema);
      } catch (e) { /* Os cartões continuam funcionais se um app alterar o JSON-LD. */ }
    }

    function trocar(doc) {
      qsa(root, '[data-lzc-swap]').forEach(function (el) {
        var nome = el.getAttribute('data-lzc-swap');
        var novo = doc.querySelector('[data-lzc-swap="' + nome + '"]');
        if (!novo) return;
        if (nome === 'grid' || nome === 'more' || nome === 'chips') el.replaceWith(novo.cloneNode(true));
        else el.innerHTML = novo.innerHTML;
      });
    }

    function aplicar(url, opt) {
      opt = opt || {};
      var grid = qs(root, '[data-lzc-swap="grid"]');
      if (grid) grid.classList.add('is-loading');
      var tag = document.activeElement;
      var foco = tag && drawer && drawer.contains(tag) && tag.name ? { n: tag.name, v: tag.value } : null;
      var req = busy = {};
      return buscar(url).then(function (doc) {
        if (req !== busy) return;
        trocar(doc);
        sincronizarSchema();
        if (opt.push !== false) history.pushState({ lzc: 1 }, '', url);
        atual = location.pathname + location.search;
        if (opt.sync) {
          var q = new URL(url, location.origin).searchParams.get('sort_by') || '';
          if (sort) sort.value = q;
        }
        /* o elemento focado (etiqueta removida, "Limpar filtros") sumiu: o foco vai para o botão Filtrar */
        if (!foco && tag && !document.contains(tag)) { var fb = qs(root, '[data-lzc-open]') || qs(root, '[data-lzc-sort]'); if (fb) fb.focus({ preventScroll: true }); }
        if (foco) {
          var el = qsa(drawer, 'input').filter(function (i) { return i.name === foco.n && i.value === foco.v; })[0];
          if (el) el.focus({ preventScroll: true });
        }
      }).catch(function () { location.href = url; });
    }

    function carregarMais(a) {
      var url = a.getAttribute('href');
      a.setAttribute('aria-busy', 'true');
      buscar(url).then(function (doc) {
        var grid = qs(root, '[data-lzc-grid]');
        var novos = doc.querySelectorAll('[data-lzc-grid] > a.lzc-card');
        Array.prototype.forEach.call(novos, function (c) { grid.appendChild(document.importNode(c, true)); });
        var more = qs(root, '[data-lzc-swap="more"]'), nm = doc.querySelector('[data-lzc-swap="more"]');
        if (more && nm) more.replaceWith(nm.cloneNode(true));
        sincronizarSchema();
      }).catch(function () { location.href = url; });
    }

    if (form) {
      form.addEventListener('change', function () { clearTimeout(timer); timer = setTimeout(function () { aplicar(urlDoForm()); }, 200); });
      form.addEventListener('submit', function (e) { e.preventDefault(); clearTimeout(timer); aplicar(urlDoForm()); fechar(); });
    }
    if (sort) sort.addEventListener('change', function () { aplicar(urlDoForm()); });
    root.addEventListener('click', function (e) {
      var l = e.target.closest('[data-lzc-link]');
      if (l && !e.metaKey && !e.ctrlKey && !e.shiftKey && l.getAttribute('href')) {
        e.preventDefault();
        aplicar(l.getAttribute('href'), { sync: true });
        if (l.hasAttribute('data-lzc-clear') && form) form.reset();
        return;
      }
      var m = e.target.closest('[data-lzc-more]');
      if (m && !e.metaKey && !e.ctrlKey && !e.shiftKey) { e.preventDefault(); carregarMais(m); }
    });
    window.addEventListener('popstate', function () {
      /* voltar de uma âncora (#escolha) não muda a lista: não refaz a busca */
      if (location.pathname + location.search === atual) return;
      aplicar(location.pathname + location.search, { push: false, sync: true });
    });
  }

  function initHero(root) {
    if (root.__lzcHero) return;
    root.__lzcHero = true;
    var p = qs(root, '.lzc-hero__p'), b = qs(root, '.lzc-hero__more');
    if (!p || !b || !window.matchMedia) return;
    var mq = matchMedia('(max-width: 759px)');
    function medir() {
      if (b.getAttribute('aria-expanded') === 'true') return;
      p.classList.remove('is-clamp');
      if (!mq.matches) { b.hidden = true; return; }
      p.classList.add('is-clamp');
      b.hidden = !(p.scrollHeight > p.clientHeight + 2);
      if (b.hidden) p.classList.remove('is-clamp');
    }
    b.addEventListener('click', function () { p.classList.remove('is-clamp'); b.setAttribute('aria-expanded', 'true'); b.hidden = true; });
    medir();
    window.addEventListener('resize', medir);
  }

  function initFaq(root) {
    if (root.__lzcFaq) return;
    root.__lzcFaq = true;
    var items = qsa(root, 'details');
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  function init(scope) {
    var s = scope && scope.querySelectorAll ? scope : document;
    qsa(s, '[data-lzc]').forEach(initMain);
    qsa(s, '.lzc-hero').forEach(initHero);
    qsa(s, '[data-lzc-faq]').forEach(initFaq);
  }

  stickyOffset();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
